/**
 * Maps a notification's `type` (and `subType`/`level` where relevant) to the
 * icon + colour pairing shown in its avatar and type badge. Shared by
 * NotificationList and NotificationItem so the two views (desktop rows /
 * mobile cards) stay visually consistent.
 */
import {
  LocalShipping as ShippingIcon,
  CheckCircle as DeliveredIcon,
  Info as InfoIcon,
  AccountBalanceWallet as WithdrawalIcon,
  Payments as TopupIcon,
  AccountBalance as BankIcon,
  WhatsApp as WhatsAppIcon,
  ReceiptLong as ApprovalIcon,
  ReportProblem as StuckParcelIcon,
} from '@mui/icons-material';
import {
  SUCCESS_FG, SUCCESS_BG,
  ERROR_FG, ERROR_BG,
  INFO_FG, INFO_BG,
  PURPLE_MAIN, BG_PURPLE_TINT, BORDER_PURPLE,
  TEXT_SECONDARY, BG_TINT, BORDER,
} from '../components/bento/bentoTokens';

const PURPLE = { color: PURPLE_MAIN, bg: BG_PURPLE_TINT, border: BORDER_PURPLE };
const SUCCESS = { color: SUCCESS_FG, bg: SUCCESS_BG, border: '#86efac' };
const ERROR = { color: ERROR_FG, bg: ERROR_BG, border: '#fca5a5' };
const INFO = { color: INFO_FG, bg: INFO_BG, border: '#93c5fd' };
const NEUTRAL = { color: TEXT_SECONDARY, bg: BG_TINT, border: BORDER };

export const getNotificationVisual = (notification = {}) => {
  switch (notification.type) {
    case 'withdrawal':
      return { Icon: WithdrawalIcon, badgeLabel: 'Withdrawal', ...ERROR };
    case 'wallet_topup_request':
      return { Icon: TopupIcon, badgeLabel: 'Top-up', ...SUCCESS };
    case 'bank_account':
      return { Icon: BankIcon, badgeLabel: 'Bank', ...INFO };
    case 'shipping_payment_approval':
    case 'branch_expense_approval':
    case 'service_charge_approval':
    case 'package_change_request':
      return { Icon: ApprovalIcon, badgeLabel: 'Approval', ...PURPLE };
    case 'whatsapp_alert':
      return notification.level === 'error'
        ? { Icon: WhatsAppIcon, badgeLabel: 'WhatsApp', ...ERROR }
        : { Icon: WhatsAppIcon, badgeLabel: 'WhatsApp', ...PURPLE };
    case 'stuck_parcel':
      return notification.level === 'error'
        ? { Icon: StuckParcelIcon, badgeLabel: 'Parcel Alert', ...ERROR }
        : { Icon: StuckParcelIcon, badgeLabel: 'Parcel Alert', ...INFO };
    case 'package_update': {
      const delivered = notification.station?.finalStation || notification.status?.toLowerCase() === 'delivered';
      return delivered
        ? { Icon: DeliveredIcon, badgeLabel: 'Delivered', ...SUCCESS }
        : { Icon: ShippingIcon, badgeLabel: 'Package', ...PURPLE };
    }
    default:
      return { Icon: InfoIcon, badgeLabel: 'System', ...NEUTRAL };
  }
};
